import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-courses-tab-1-part',
	standalone: true,
	templateUrl: './experience-courses-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-courses-tab-1.part.scss`],
})
export class ExperienceCoursesTab1Part {
}
